export default function SortBar({ sort, onChange }){
  return (<div className="flex items-center gap-2 text-sm">
    <span className="text-slate-600">Sort</span>
    <select value={sort} onChange={e=>onChange(e.target.value)} className="rounded-lg border border-slate-200 px-2 py-1">
      <option value="">Relevance</option>
      <option value="price-asc">Price: Low to High</option>
      <option value="price-desc">Price: High to Low</option>
    </select>
  </div>);
}
